import { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import Select from "react-select";
import SubscriptionService from "../../../../services/SubscriptionService";

const Subscription = () => {
	const lang = useSelector((state) => state.auth?.lang);
	const typesOptions = [
		{ label: Translate[lang].monthly, value: "monthly" },
		{ label: Translate[lang].annually, value: "annually" },
	];
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(0);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const subscriptionService = new SubscriptionService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const search = useSelector((state) => state.auth.search);
	const [params, setParams] = useState({});
	const [paramsData, setParamsData] = useState({
		subscription_type: "",
		subscriptionDate: "",
	});

	useEffect(() => {
		// if (!!paramsData?.subscription_type || !!paramsData?.date) {
		let paramsUpdate = {};
		if (!!paramsData?.subscription_type)
			paramsUpdate["subscription_type"] = paramsData?.subscription_type?.value;
		if (!!paramsData?.subscriptionDate)
			paramsUpdate["subscriptionDate"] = paramsData?.subscriptionDate;
		setParams(paramsUpdate);
		setShouldUpdate((prev) => !prev);
		// }
	}, [paramsData]);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].subscription}
						</span>
					</div>
				</div>
			</div>
			<div class="accordion " id="accordionExample">
				<div class="accordion-item border-shadow p-0">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button fw-bold"
							type="button"
							style={{
								fontSize: "18px",
								background: "none",
								boxShadow: "none",
								color: "#000",
							}}
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne">
							{Translate[lang].filter}
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample">
						<div class="accordion-body px-0">
							<div className="row w-100 m-auto">
								<div className="col-md-3 col-6">
									<label className="d-block fw-bold">
										{Translate[lang].date}
									</label>
									<input
										type="date"
										name={"date"}
										value={paramsData?.subscriptionDate}
										placeholder={Translate[lang].date}
										style={{
											height: "43px",
											padding: "0 10px",
											borderRadius: "10px",
											border: "1px solid hsl(0, 0%, 80%)",
											width: "100%",
										}}
										onChange={(e) =>
											setParamsData((prev) => ({
												...prev,
												subscriptionDate: e.target?.value,
											}))
										}
									/>
								</div>
								<div className="col-md-3 col-6">
									<label className="fw-bold">{Translate[lang].type}</label>
									<Select
										options={typesOptions}
										value={paramsData?.subscription_type}
										onChange={(e) => {
											setParamsData((prev) => ({
												...prev,
												subscription_type: e,
											}));
										}}
									/>
								</div>
								<div className={"col-md-2 col-6"}>
									<div className="d-flex h-100 gap-8 align-items-center mt-3">
										{(!!paramsData?.subscription_type ||
											!!paramsData?.subscriptionDate) && (
											<Button
												variant="outline-danger"
												className="w-100"
												onClick={() => {
													setParamsData({
														subscriptionDate: "",
														subscription_type: "",
													});
												}}>
												{Translate[lang].clear_filter}
											</Button>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="mt-4">
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.phone}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.package_name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.price_type}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.date}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.expiry_date}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.status}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.length > 0 &&
									data?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setData}
						service={subscriptionService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						param={params}
					/>
				</div>
			</div>
		</div>
	);
};
export default Subscription;
